import Vue from 'vue'
import Vuex from 'vuex'
import { state } from './state'
import * as getters from './getters'
import { actions } from './actions'
import * as mutations from './mutations'

Vue.use(Vuex);

let store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});

export default store


// WEBPACK FOOTER //
// ./webapp/store/index.js